export default __webpack_public_path__ + "static/media/add-icon.3e8d7acd.svg";